import { SiInstagram } from "react-icons/si";
import { FiFacebook, FiLinkedin } from "react-icons/fi";
import Link from "next/link";

const Footer = () => {
  return (
    <footer className="bg-foreground/5 py-8 border-t border-border mt-auto">
      <div className="container mx-auto px-4">
        {/* Fixed height container to prevent CLS when icons load */}
        <div className="flex justify-center gap-6 mb-4 min-h-[26.4px]">
          <a
            href="https://www.facebook.com/getguardianservice"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors block w-[26.4px] h-[26.4px]"
            aria-label="Facebook"
          >
            <FiFacebook className="w-[26.4px] h-[26.4px]" />
          </a>
          <a
            href="https://www.instagram.com/meetguardianservice/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors block w-[26.4px] h-[26.4px]"
            aria-label="Instagram"
          >
            <SiInstagram className="w-[26.4px] h-[26.4px]" />
          </a>
          <a
            href="https://www.linkedin.com/company/guardian-service-protection/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors block w-[26.4px] h-[26.4px]"
            aria-label="LinkedIn"
          >
            <FiLinkedin className="w-[26.4px] h-[26.4px]" />
          </a>
        </div>
        <div className="text-center text-muted-foreground text-sm">
          <p className="md:inline">
            &copy; 2024-2026 Guardian Service Holdings LLC.
          </p>
          <p className="md:inline"> All rights reserved.</p>
          <p className="block my-4 max-w-2xl mx-auto">
            Guardian Service is a licensed agency with 100% US-based salaried
            agents. We do not sell your information or send spam, and your data
            is securely used only to serve your insurance needs.
          </p>
          <p className="block my-4 max-w-2xl mx-auto">
            ‘Never Shop for Insurance Again’ is a registered trademark of Guardian Service Holdings LLC.
          </p>
          <div className="flex flex-row md:flex-row justify-center items-center gap-2 md:gap-6 mt-2">
            <Link
              href="/terms-of-use"
              className="hover:text-foreground transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              href="/privacy-policy"
              className="hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
